// src/pages/noticias/VerNoticia.js
import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import { Offcanvas, Card } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import RichTextPreview from 'components/RichText/RichTextPreview'
import { TIPO_NOTICIA_NORMAL } from 'config/noticias'

import './noticias.css'

function VerNoticia(props) {
	const { noticia, setQueMostrar } = props

	// Normalizar el valor de borrador
	const esBorrador = noticia.borrador === '1' || noticia.borrador === 1 || noticia.borrador === true

	// Formatear la fecha para visualización
	const formatearFecha = (fechaString) => {
		const fecha = new Date(fechaString)
		return fecha.toLocaleDateString('es-ES', {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		})
	}

	const handleClose = () => {
		setQueMostrar('')
	}

	// Preparar el contenido para RichTextPreview si existe
	const renderContenido = () => {
		if (!noticia.contenido) return <p className="text-muted">No hay contenido disponible</p>

		try {
			// Intentar parsear el contenido como JSON para RichTextPreview
			const contenidoJSON = JSON.parse(noticia.contenido)
			return <RichTextPreview rawContent={contenidoJSON} />
		} catch (e) {
			// Si no es JSON, mostrarlo como texto plano
			return <div className="contenido-text">{noticia.contenido}</div>
		}
	}

	// Obtener URL de la imagen (con fallback)
	const getImagenUrl = () => {
		if (noticia.imagen && noticia.imagen.url) {
			return `${process.env.REACT_APP_API_URL}${noticia.imagen.url}`
		}
		return 'https://via.placeholder.com/600x400?text=Sin+imagen'
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" className="noticia-detalle-panel">
			<PanelHeader
				onClick={handleClose}
				iconClass="fa-arrow-left"
				btnText="Atrás"
				text={esBorrador ? "Noticia (Borrador)" : "Noticia"}
			/>
			<Offcanvas.Body id="ver-noticia" className="pb-0">
				<Card className="noticia-card mb-4 border-0 shadow-sm">
					{noticia.tipo === TIPO_NOTICIA_NORMAL && (
						<div className="imagen-container">
							<img
								src={getImagenUrl()}
								alt={noticia.titulo}
								className="noticia-imagen"
							/>

							{esBorrador && (
								<Badge bg="warning" className="estado-badge">
									<i className="fa fa-pencil-alt me-1"></i> Borrador
								</Badge>
							)}

							<div className="fecha-publicacion">
								<i className="fa fa-calendar-alt me-2"></i>
								{formatearFecha(noticia.fecha)}
							</div>
						</div>
					)}

					<Card.Body>
						<div className="mb-4">
							<div className="d-flex flex-wrap mb-2">
								{noticia.etiquetas && noticia.etiquetas.length > 0 ? (
									noticia.etiquetas.map((etiqueta, index) => (
										<Badge
											key={index}
											bg="primary"
											className="me-2 mb-2 px-3 py-2"
										>
											{etiqueta.nombre}
										</Badge>
									))
								) : (
									<Badge bg="secondary" className="me-2 mb-2 px-3 py-2">
										Sin etiquetas
									</Badge>
								)}
							</div>

							<h1 className="titulo-noticia">{noticia.titulo}</h1>

							{noticia.autor && (
								<div className="autor-noticia">
									<i className="fa fa-user me-2"></i>
									Por <strong>{noticia.autor}</strong>
								</div>
							)}
						</div>

						{noticia.copete && (
							<div className="copete-container mb-4">
								<div className="copete-noticia">
									{noticia.copete}
								</div>
							</div>
						)}

						<div className="contenido-container">
							{renderContenido()}
						</div>

						{noticia.link && (
							<div className="mt-4 link-container">
								<h5 className="mb-2">Enlace relacionado:</h5>
								<a
									href={noticia.link}
									target="_blank"
									rel="noopener noreferrer"
									className="btn btn-outline-primary"
								>
									<i className="fa fa-external-link-alt me-2"></i>
									Ver enlace original
								</a>
							</div>
						)}
					</Card.Body>

					<Card.Footer className="bg-white border-0 pt-0">
						<Row className="mt-4">
							<Col>
								<div className="detalles-adicionales">
									<small className="text-muted">
										<strong>ID:</strong> {noticia.id} |
										<strong> Creada:</strong> {formatearFecha(noticia.fechaCreacion)}
									</small>
								</div>
							</Col>
						</Row>
					</Card.Footer>
				</Card>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose} className="w-100">
					Cerrar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerNoticia